/**
 * * IMP: ToolPane reducer is a special case, where we do mutation in
 * * reducer file. The reason for doing, currently this reducer holds only 3 states
 * * and 2 of them are optional values. Since no complex mutation is involved this
 * * approach was taken. This might get changed if complex logic is added in future.
 */

export default (
  state = {
    view: "",
    page: "",
    isOpen: false,
    addComponentType: null,
    sectionDataForSignature: {},
    sectionDataForStripePayment: {},
  },
  action,
) => {
  switch (action.type) {
    case "UPDATE_TOOLPANE_DATA":
      return {
        ...state,
        view: action.payload.view ? action.payload.view : state.view,
        page: action.payload.page ? action.payload.page : state.page,
        isOpen: action.payload.isOpen,
      };
    case "UPDATE_TOOLPANE_DATA_FOR_SIGNATURE":
      return {
        ...state,
        addComponentType:
          action.payload.sectionData && action.payload.sectionData.type,
        sectionDataForSignature: action.payload.sectionData,
      };
    case "NUKE_QUOTATION_DATA":
      return {
        ...state,
        view: "",
        page: "",
        isOpen: false,
      };
    case "NUKE_TEMPLATE":
    case "NUKE_DOCUMENT":
      return {
        ...state,
        view: "",
        page: "",
        isOpen: false,
      };
    case "UPDATE_ADD_COMPONENT_TYPE":
      return {
        ...state,
        addComponentType: action.payload,
      };
    case "UPDATE_TOOLPANE_DATA_FOR_STRIPE_PAYMENT":
      return {
        ...state,
        addComponentType:
          action.payload.sectionData && action.payload.sectionData.type,
        sectionDataForStripePayment: action.payload.sectionData,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/ToolPaneReducer.js